import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { UIRouterModule } from '@uirouter/angular';

import { ComponentsModule } from '../components/components.module';
import { PresentationsModule } from '../presentations/presentations.module';
import { SharedModule } from '../shared/shared.module';
import { routes } from './ai-chatbot.routes';

import { TemplateEditorModule } from '../template-editor/template-editor.module';
import { AiChatbotBrandingToggleComponent } from './components/ai-chatbot-branding-toggle/ai-chatbot-branding-toggle.component';
import { AiChatbotChatScrollComponent } from './components/ai-chatbot-chat-scroll/ai-chatbot-chat-scroll.component';
import { AiChatbotCreditsMenuComponent } from './components/ai-chatbot-credits-menu/ai-chatbot-credits-menu.component';
import { AiChatbotCreditsOverlayComponent } from './components/ai-chatbot-credits-overlay/ai-chatbot-credits-overlay.component';
import { AiChatbotLoadingComponent } from './components/ai-chatbot-loading/ai-chatbot-loading.component';
import { AiChatbotMessageFeedbackComponent } from './components/ai-chatbot-message-feedback/ai-chatbot-message-feedback.component';
import { AiChatbotMessageComponent } from './components/ai-chatbot-message/ai-chatbot-message.component';
import { AiChatbotModeToggleComponent } from './components/ai-chatbot-mode-toggle/ai-chatbot-mode-toggle.component';
import { AiChatbotPromptBoxComponent } from './components/ai-chatbot-prompt-box/ai-chatbot-prompt-box.component';
import { AiChatbotSuggestionsComponent } from './components/ai-chatbot-suggestions/ai-chatbot-suggestions.component';
import { AiChatbotComponent } from './components/ai-chatbot/ai-chatbot.component';
import { AiCreditsModalComponent } from './components/ai-credits-modal/ai-credits-modal.component';
import { TemplateTunerPreviewComponent } from './components/template-tuner-preview/template-tuner-preview.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    UIRouterModule.forChild(routes),
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatChipsModule,
    MatMenuModule,
    MatCheckboxModule,
    MatInputModule,
    ComponentsModule,
    TemplateEditorModule,
    PresentationsModule,
    SharedModule,
  ],
  declarations: [
    AiChatbotComponent,
    AiChatbotBrandingToggleComponent,
    AiChatbotChatScrollComponent,
    AiChatbotCreditsMenuComponent,
    AiChatbotPromptBoxComponent,
    AiChatbotLoadingComponent,
    AiChatbotMessageComponent,
    AiChatbotMessageFeedbackComponent,
    AiChatbotModeToggleComponent,
    AiChatbotSuggestionsComponent,
    AiCreditsModalComponent,
    TemplateTunerPreviewComponent,
    AiChatbotCreditsOverlayComponent,
  ],
  exports: [
    AiChatbotComponent,
    AiChatbotPromptBoxComponent,
    AiChatbotLoadingComponent,
    AiChatbotMessageComponent,
  ],
  providers: [],
})
export class AIChatbotModule {}
